import { CircularProgress } from "@mui/material";
import { Grid } from "@mui/material";

export default function LoadingOverlay() {
  return (
    <Grid container justifyContent="center" alignItems="center">
      <CircularProgress />
    </Grid>
  );
}
